export default {
    state: {
      data: false,
    },
    getters: {
      //
    },
    actions: {
      resetMiniGame(context) {
        context.commit("updateMiniGame", false)
      },
    },
    mutations: {
      updateMiniGame(state, data) {
        return state.data = data
      }
    }
  }